var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"about-hero"},[_vm._m(0),_c('div',{staticClass:"about-hero-image"},[_c('img',{attrs:{"src":_vm.leatherCraft2,"alt":"Our Leather Collection"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-hero-text"},[_c('h1',[_vm._v("About Us ")]),_c('p',[_vm._v("Discover the story behind our passion for quality leather and timeless craftsmanship.")])])
}]

export { render, staticRenderFns }